module.exports = __webpack_public_path__ + "img/ring_y_s_0_null@3x.6fb55e09.png";